import createVueComponent from '../createVueComponent';

const CornerDownRight = createVueComponent('CornerDownRightIcon', [
  ['polyline', { points: '15 10 20 15 15 20', key: '1q7qjw' }],
  ['path', { d: 'M4 4v7a4 4 0 0 0 4 4h12', key: 'z08zvw' }],
]);

export default CornerDownRight;
